module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/21-bfa22389a730b19757aa95fa66ba247e.jpg";